/* TVC Patches v4
   Loaded AFTER tvc-app.js. Responsibilities:
   (1) Log every PayPal form submission to Google Sheets.
   (2) For digital products, fix the PayPal modal display + ensure the
       customer is charged product price only (no ₹2500 shipping addition).
   (3) Country allowlist for PayPal: only US, CA, GB, AU, MY, SG, AE see PayPal.
   (4) Minimum order ₹4,000 (skipped for digital products).
   (5) For non-allowlist countries (FR, DE, JP, BR, ZA, etc.): hide PayPal CTAs
       AND Shopify dynamic checkout strip (Shop Pay / GPay / Apple Pay), and
       route them through the standard Shopify "Checkout" button -> Razorpay.
*/
(function(){
  var SHEETS_URL = "https://script.google.com/macros/s/AKfycbxK461k_hfW3PhjcK800Bb75YZk3bw5eOKp4kd4Da9mIB5dh-4T7z5GPrTmgj2bryE/exec";
  var ALLOWED_COUNTRIES = ["US","CA","GB","AU","MY","SG","AE"];
  var MIN_ORDER_INR = 4000;

  function val(id){ var el = document.getElementById(id); return el ? (el.value || "").trim() : ""; }

  function getProductPriceNumber(){
    var rows = document.querySelectorAll(".tvc-pp-checkout-summary-row");
    if (!rows.length) return 0;
    var spans = rows[0].querySelectorAll("span");
    if (spans.length !== 2) return 0;
    return parseFloat((spans[1].textContent || "0").replace(/[^\d.]/g, "")) || 0;
  }

  function getProductPriceText(){
    var rows = document.querySelectorAll(".tvc-pp-checkout-summary-row");
    if (!rows.length) return "";
    var spans = rows[0].querySelectorAll("span");
    if (spans.length !== 2) return "";
    return (spans[1].textContent || "").trim();
  }

  function rewritePaypalUrl(url){
    if (typeof url !== "string" || url.indexOf("paypal.me/vediccrystals1") === -1) return url;
    var m = url.match(/(.+\/)([0-9.]+)([A-Z]+)$/);
    if (!m) return url;
    var price = getProductPriceNumber();
    if (price <= 0) return url;
    return m[1] + price.toFixed(2) + m[3];
  }

  function readSummary(){
    var data = { product:"", variant:"", price:"", shipping:"", total:"" };
    var rows = document.querySelectorAll(".tvc-pp-checkout-summary-row");
    for (var i = 0; i < rows.length; i++) {
      var spans = rows[i].querySelectorAll("span");
      if (spans.length !== 2) continue;
      var lbl = (spans[0].textContent || "").trim();
      var v   = (spans[1].textContent || "").trim();
      if (i === 0) { data.product = lbl; data.price = v; }
      else if (lbl.indexOf("Variant:") === 0) data.variant = lbl.replace(/^Variant:\s*/, "");
      else if (lbl.indexOf("International Shipping") === 0) data.shipping = v;
      else if (lbl === "Total") data.total = v;
    }
    return data;
  }

  function fixModalForDigital(modal){
    if (!modal || !window.__tvcDigitalProduct) return;
    var rows = modal.querySelectorAll(".tvc-pp-checkout-summary-row");
    var shippingRow = null, totalRow = null, priceRow = null;
    for (var i = 0; i < rows.length; i++) {
      var spans = rows[i].querySelectorAll("span");
      if (spans.length !== 2) continue;
      var lbl = (spans[0].textContent || "").trim();
      if (lbl.indexOf("International Shipping") === 0) shippingRow = rows[i];
      else if (lbl === "Total") totalRow = rows[i];
      else if (!priceRow && lbl.indexOf("Variant:") !== 0) priceRow = rows[i];
    }
    if (shippingRow) shippingRow.style.display = "none";
    if (priceRow && totalRow) {
      var pSpans = priceRow.querySelectorAll("span");
      var tSpans = totalRow.querySelectorAll("span");
      if (pSpans.length === 2 && tSpans.length === 2) {
        tSpans[1].textContent = pSpans[1].textContent;
      }
    }
  }

  function fixPostSubmitUrls(modal){
    if (!modal || !window.__tvcDigitalProduct) return;
    var priceText = getProductPriceText();
    var links = modal.querySelectorAll('a[href*="paypal.me/vediccrystals1"]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute("href", rewritePaypalUrl(links[i].getAttribute("href")));
      if (priceText) {
        for (var j = 0; j < links[i].childNodes.length; j++) {
          var node = links[i].childNodes[j];
          if (node.nodeType === 3 && /Pay\s+\S+\s+Now/.test(node.nodeValue)) {
            node.nodeValue = node.nodeValue.replace(/Pay\s+\S+\s+Now/, "Pay " + priceText + " Now");
          }
        }
      }
    }
    var divs = modal.querySelectorAll("div");
    for (var k = 0; k < divs.length; k++) {
      if (divs[k].children.length === 0) {
        var txt = (divs[k].textContent || "").trim();
        if (/^https?:\/\/.+paypal\.me\/vediccrystals1\/[0-9.]+[A-Z]+$/.test(txt)) {
          divs[k].textContent = rewritePaypalUrl(txt);
        }
      }
    }
    if (priceText) {
      var headers = modal.querySelectorAll('div[style*="font-weight:700"]');
      for (var h = 0; h < headers.length; h++) {
        var ht = headers[h].textContent || "";
        if (/^Pay\s+\S+\s+via\s+PayPal/i.test(ht.trim())) {
          headers[h].textContent = ht.replace(/^Pay\s+\S+\s+via/i, "Pay " + priceText + " via");
        }
      }
    }
  }

  function isBlockedCountry(){
    var c = window.__saGeoCountry;
    if (!c) return false;
    if (c === "IN") return false;
    return ALLOWED_COUNTRIES.indexOf(c) === -1;
  }

  // For blocked countries (non-IN, outside PayPal allowlist):
  //   - Hide PayPal modal CTAs (they should never see PayPal)
  //   - Hide international shipping notice (Razorpay checkout handles its own shipping)
  //   - Hide Shopify dynamic checkout buttons (Shop Pay / GPay / Apple Pay strip)
  //     so the visitor defaults to the standard Shopify "Checkout" button -> Razorpay.
  function hidePaypalElements(){
    if (!isBlockedCountry()) return;
    var els = document.querySelectorAll(".tvc-paypal-wrap, .tvc-shipping-notice, .tvc-intl-banner, .shopify-payment-button, [data-shopify-buttoncontainer], .dynamic-checkout, .dynamic-checkout__content, .additional-checkout-buttons");
    for (var i = 0; i < els.length; i++) els[i].style.display = "none";
  }

  function showMinOrderAlert(){
    var fx = window.__saFxLastRate || 1;
    var min = Math.ceil(MIN_ORDER_INR * fx);
    var cur = window.__saFxTargetCurrency || "INR";
    var symMap = {USD:"$",GBP:"£",EUR:"€",AED:"AED ",SAR:"SAR ",AUD:"A$",CAD:"CA$",SGD:"S$",MYR:"RM "};
    var sym = symMap[cur] || (cur + " ");
    alert("Minimum order for international shipping is " + sym + min.toLocaleString() + " . For orders under this amount, please WhatsApp us at +91 9811 809 967.");
  }

  var geoWaitCount = 0;
  var geoInterval = setInterval(function(){
    geoWaitCount++;
    if (window.__saGeoCountry) {
      clearInterval(geoInterval);
      hidePaypalElements();
    }
    if (geoWaitCount > 60) clearInterval(geoInterval);
  }, 250);

  // For blocked countries: kill ONLY the Shopify dynamic checkout buttons
  // (Shop Pay, Apple Pay, Google Pay, etc.). Regular Shopify "Checkout" /
  // "Buy Now" buttons MUST remain clickable so non-allowlist visitors
  // (FR, DE, JP, BR, ZA, etc.) can complete purchase via Razorpay-backed
  // Shopify standard checkout. This is defence-in-depth: the strip is also
  // hidden visually by hidePaypalElements once geo resolves, but this catches
  // any clicks during the brief window before geo resolves.
  window.addEventListener("click", function(e){
    if (!isBlockedCountry()) return;
    var dynamicCheckoutSel = '.shopify-payment-button, .shopify-payment-button button, .shopify-payment-button__button, [data-shopify-buttoncontainer], [data-shopify-buttoncontainer] button, .dynamic-checkout, .dynamic-checkout__button, .dynamic-checkout__content, .additional-checkout-buttons, .additional-checkout-buttons button';
    if (e.target.closest(dynamicCheckoutSel)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  document.addEventListener("click", function(e){
    var btn = e.target.closest(".tvc-paypal-btn");
    if (!btn) return;
    if (window.__tvcMinPassed) return;
    if (isBlockedCountry()) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    var isProductPage = window.location.pathname.indexOf("/products/") > -1;
    if (isProductPage && !window.__tvcDigitalProduct) {
      var el = document.querySelector(".price__regular .price-item--regular,.price .money,.price-item--sale");
      if (el) {
        var num = parseFloat(el.textContent.trim().replace(/[^\d.,]/g, "").replace(/,/g, ""));
        var fx = window.__saFxLastRate;
        if (num && fx && fx > 0 && (num / fx) < MIN_ORDER_INR) {
          e.preventDefault();
          e.stopPropagation();
          showMinOrderAlert();
        }
      }
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var anyPhysical = cart.items && cart.items.some(function(i){ return i.requires_shipping !== false; });
        if (anyPhysical && cart.total_price < (MIN_ORDER_INR * 100)) {
          showMinOrderAlert();
          return;
        }
        window.__tvcMinPassed = true;
        btn.click();
        setTimeout(function(){ window.__tvcMinPassed = false; }, 500);
      })
      .catch(function(){
        window.__tvcMinPassed = true;
        btn.click();
        setTimeout(function(){ window.__tvcMinPassed = false; }, 500);
      });
  }, true);

  document.addEventListener("click", function(evt){
    var t = evt.target;
    if (!t || t.id !== "tvc-pp-submit") return;
    var name    = val("tvc-pp-name");
    var email   = val("tvc-pp-email");
    var phone   = val("tvc-pp-phone");
    var address = val("tvc-pp-address");
    var city    = val("tvc-pp-city");
    var state   = val("tvc-pp-state");
    var zip     = val("tvc-pp-zip");
    var country = val("tvc-pp-country");
    if (!name || !email || !phone || !address || !city || !country) return;
    if (window.__tvcDigitalProduct) {
      var origOpen = window.open;
      window.open = function(url, target, features){
        return origOpen.call(window, rewritePaypalUrl(url), target, features);
      };
      setTimeout(function(){ window.open = origOpen; }, 3000);
    }
    var sum = readSummary();
    try {
      fetch(SHEETS_URL, {
        method: "POST",
        mode: "no-cors",
        keepalive: true,
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify({
          name: name, email: email, phone: phone,
          address: address, city: city, state: state, zip: zip, country: country,
          product: sum.product, variant: sum.variant,
          price: sum.price, shipping: sum.shipping, total: sum.total,
          currency:   window.__saFxTargetCurrency || "INR",
          countryGeo: window.__saGeoCountry || "",
          pageUrl:    window.location.href,
          paypalLink: "",
          isDigital:  !!window.__tvcDigitalProduct,
          submittedAt: new Date().toISOString()
        })
      }).catch(function(){});
    } catch (_) {}
  }, true);

  if (window.MutationObserver) {
    var modalRef = null;
    new MutationObserver(function(mutations){
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.classList) {
            if (node.classList.contains("tvc-pp-checkout-overlay")) {
              modalRef = node;
              (function(n){ setTimeout(function(){ fixModalForDigital(n); }, 10); })(node);
            }
            // Hide dynamically-added PayPal CTAs and Shopify dynamic checkout strip
            // for blocked countries (catches AJAX re-renders, variant changes, etc.)
            if (isBlockedCountry() && (
                node.classList.contains("tvc-paypal-wrap") ||
                node.classList.contains("tvc-shipping-notice") ||
                node.classList.contains("tvc-intl-banner") ||
                node.classList.contains("shopify-payment-button") ||
                node.classList.contains("dynamic-checkout") ||
                node.classList.contains("dynamic-checkout__content") ||
                node.classList.contains("additional-checkout-buttons") ||
                (node.hasAttribute && node.hasAttribute("data-shopify-buttoncontainer"))
            )) {
              node.style.display = "none";
            }
          }
        }
        if (modalRef && mutations[i].target) {
          var tgt = mutations[i].target;
          if (tgt === modalRef || (modalRef.contains && modalRef.contains(tgt))) {
            (function(m){ setTimeout(function(){ fixPostSubmitUrls(m); }, 40); })(modalRef);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* ═══ PayPal Checkout API loader (staging, opt-in) ═══
   Injects tvc-paypal-api.js so the new PayPal Smart Buttons can
   enhance the existing paypal.me modal. No-op for IN visitors and
   for countries outside the existing allowlist (modal never opens). */
(function(){
  if (window.__tvcPayPalConfig) return;
  window.__tvcPayPalConfig = {
    workerBase: 'https://late-grass-18d9.gauravbsharma.workers.dev',
    enabled: true,
    debug: true
  };
  function inject(){
    if (document.getElementById('tvc-paypal-api-script')) return;
    var ref = document.querySelector('script[src*="tvc-app.js"]') ||
              document.querySelector('script[src*="/cdn/shop/"]');
    var src = ref ? ref.src.replace(/[^\/]+\.js(\?[^"]*)?$/, 'tvc-paypal-api.js') : null;
    if (!src) return;
    var s = document.createElement('script');
    s.id = 'tvc-paypal-api-script';
    s.src = src;
    s.defer = true;
    document.head.appendChild(s);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();

/* The previous /collections/all finder-mover IIFE was removed.
   The "Find Your Vedic Remedy" widget is now rendered server-side as a
   section entry in templates/collection.json, restricted to
   collection.handle == 'all' by sections/vedic-remedy-finder-section.liquid.
   No JavaScript positioning needed. */

/* ═══ Hide Vedic Remedy Finder on ALL collection pages — added 17 Jun 2026 ═══
   The layout/theme.liquid file renders #tvc-find-remedy inline on every
   collection page (its conditional includes template.name == 'collection').
   The templates/collection.json also includes the section render. Either or
   both create finder widgets on every collection page. Per merchant request:
   no finder widget anywhere on collection pages — including /collections/all.
   The finder continues to work on homepage / blog / article pages.

   This works in 3 stages so the widget is hidden as early as possible:
   (1) Inject a <style> tag immediately when the script runs (before DOM ready).
       Catches both render paths via multiple ID/class selectors.
   (2) On DOMContentLoaded, also explicitly remove the elements from the DOM.
   (3) MutationObserver catches anything dynamically re-rendered (e.g. AJAX
       pagination, infinite scroll).
*/
(function(){
  if (!/^\/collections(\/|$)/i.test(window.location.pathname)) return;

  // Stage 1: inject CSS immediately
  try {
    var s = document.createElement('style');
    s.id = 'tvc-hide-finder-on-collections';
    s.textContent =
      '#tvc-find-remedy,' +
      '#shopify-section-vedic_remedy_finder,' +
      '.tvc-finder,' +
      '.section-vedic-remedy-finder' +
      '{ display:none !important; visibility:hidden !important; height:0 !important; overflow:hidden !important; }';
    (document.head || document.documentElement).appendChild(s);
  } catch (_) {}

  // Stage 2 + 3: remove elements from DOM, with mutation observer for re-renders
  function removeFinderElements(){
    var sels = [
      '#tvc-find-remedy',
      '#shopify-section-vedic_remedy_finder',
      '.tvc-finder',
      '.section-vedic-remedy-finder'
    ];
    for (var i = 0; i < sels.length; i++) {
      var nodes = document.querySelectorAll(sels[i]);
      for (var j = 0; j < nodes.length; j++) {
        if (nodes[j].parentNode) nodes[j].parentNode.removeChild(nodes[j]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeFinderElements);
  } else {
    removeFinderElements();
  }

  if (window.MutationObserver) {
    var obs = new MutationObserver(function(){ removeFinderElements(); });
    var start = function(){
      obs.observe(document.body || document.documentElement, { childList: true, subtree: true });
      // Disconnect after 8 seconds to avoid permanent overhead
      setTimeout(function(){ obs.disconnect(); }, 8000);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  }
})();
